const brands = [
  "Ferco",
  "GU",
  "Roto",
  "Maco",
  "Siegenia",
  "Winkhaus",
  "Aubi",
  "Cadiou",
];

export default function AllBrands() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Toutes les marques
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-6 leading-tight">
            Remplacement de poignée <span className="font-serif italic">toutes marques</span>
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-6">
            Les poignées de fenêtre ne sont pas standardisées. Chaque marque a ses propres dimensions, son propre pas de vis, son propre carré d'entraînement. Une poignée Ferco ne s'adapte pas sur une crémone GU. Une poignée Maco a un axe différent d'une poignée Siegenia. C'est pourquoi il faut identifier exactement la marche et le modèle avant de commander la pièce. Chez DF PRO à Strasbourg, nous connaissons les spécificités de chaque fabricant et nous avons un stock de pièces courantes pour les marques les plus répandues en Alsace.
          </p>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8">
            Si votre fenêtre est ancienne et que la marque n'est plus visible, nous identifions le mécanisme à partir de la forme de la crémone, du pas de la poignée et de la longueur du carré. Nous avons accès à des catalogues de pièces détachées pour les modèles obsolètes. Dans tous les cas, nous trouvons la bonne poignée et nous la remplaçons chez vous, en une seule visite.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {brands.map((brand) => (
              <div
                key={brand}
                className="bg-rose-50 rounded-xl border border-rose-200 px-4 py-3 text-center"
              >
                <span className="text-plum-dark font-semibold text-sm">{brand}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}